import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const ADMIN_EMAILS = ["gentianhatillari13@gmail.com"];
export const API = `${BACKEND_URL}/api`;

export const isDemoMode = new URLSearchParams(window.location.search).get('demo') === 'true';
axios.defaults.withCredentials = !isDemoMode;

export const PRIORITY_CONFIG = { high: { label: "High", className: "priority-high" }, medium: { label: "Medium", className: "priority-medium" }, low: { label: "Low", className: "priority-low" } };
export const COLUMN_COLORS = ["#6366F1", "#8B5CF6", "#EC4899", "#EF4444", "#F59E0B", "#10B981", "#14B8A6", "#3B82F6", "#F97316", "#84CC16"];
export const TAG_COLORS = ["#EF4444", "#F59E0B", "#10B981", "#3B82F6", "#8B5CF6", "#EC4899", "#14B8A6", "#F97316", "#6366F1", "#84CC16"];
export const RECURRENCE_OPTIONS = [{ value: "daily", label: "Daily" }, { value: "weekly", label: "Weekly" }, { value: "biweekly", label: "Bi-weekly" }, { value: "monthly", label: "Monthly" }];

export const formatTime = (minutes) => {
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
};

export const mentionsToDisplay = (text) => (text || "").replace(/@\[([^\]]+)\]\(([^)]+)\)/g, '@$1');

export const mentionsToRaw = (text, people) => {
  if (!text) return text;
  let out = text;
  const sorted = [...(people || [])].filter(p => p?.name && p?.id).sort((a, b) => b.name.length - a.name.length);
  for (const p of sorted) {
    const esc = p.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    out = out.replace(new RegExp(`@${esc}(?![\\w\\]])`, 'g'), `@[${p.name}](${p.id})`);
  }
  return out;
};
